import { effect, Service, signal } from '@angular/core';

@Service()
export class SessionService {

    formSubData = signal<any>(null);

    private readonly SESSION_KEY = 'user_session';
    
  
    setSession(data: any): void {
    // default TTL: 1 hour (3600 seconds)
    this.setSessionWithTTL(data, 3600);
  }
  constructor(){
    this.formSubData.set(this.getData())
    
    effect(() => {
    const data = this.formSubData();
    if (data !== null) {
      this.saveData(data);
    }
  });
  }

  /**
   * Store session with a TTL in seconds. expiresAt stored as epoch ms.
   */
  setSessionWithTTL(data: any, ttlSeconds: number): void {
    const payload = {
      data,
      expiresAt: Date.now() + ttlSeconds * 1000
    };
    localStorage.setItem(this.SESSION_KEY, JSON.stringify(payload));
  }

  saveData(data:any){
    sessionStorage.setItem('Data',JSON.stringify(data));
  }
  getData(){
    const data = sessionStorage.getItem('Data');  
    return data ? JSON.parse(data) : null;}


  getSession(): any {
    const session = localStorage.getItem(this.SESSION_KEY);
    if (!session) return null;
    try {
      const parsed = JSON.parse(session);
      // if stored as legacy plain data (no expiresAt), return it
      if (!parsed.expiresAt) {
        return parsed;
      }
      if (parsed.expiresAt && Date.now() < parsed.expiresAt) {
        return parsed.data;
      }
      // expired
      this.clearSession();
      return null;
    } catch (e) {
      return null;
    }
  }

  clearSession(): void {
    localStorage.removeItem(this.SESSION_KEY);
  }
}
